<template>
    <v-form v-model="complete" @submit.prevent="$emit('submit', form)">
        <div class="mt-6">
            <v-text-field 
                v-model="form.name" 
                :rules="[rules.required]"
                :label="$t('components.CustomerForm.CustomerNameLabel')" 
                hint="John Cena"
                prepend-icon="mdi-account"/>

            <v-text-field 
                v-if="newCustomer"
                v-model="form.email" 
                :rules="newCustomer ? [rules.required, rules.email] : [hidden]"
                :label="$t('components.CustomerForm.CustomerEmailLabel')" 
                hint="example@domain.com"
                prepend-icon="mdi-email"/>
            
            <v-combobox 
                v-model="form.clinics" 
                :rules="[rules.requiredList]"
                :items="[]" 
                :label="$t('components.CustomerForm.CustomerClinicsLabel')" 
                :hint="$t('components.CustomerForm.CustomerClinicsHint')"
                prepend-icon="mdi-hospital-building"
                append-icon=" "
                multiple chips/>

            <v-divider class="mt-3 mb-5"></v-divider>

            <h4>Report configuration</h4>
            <ReportControls class="my-3" :customer="form" @updated="reportUpdated"/>

            <v-divider class="mt-3 mb-5"></v-divider>

            <h4>A/B Test ID</h4>
            <ABTestControls class="my-3" :customer="form" :available="appVersions"/>

            <div class="d-block text-right mt-4">
                <v-btn color="success" type="submit" elevation="2" :disabled="!complete">
                    <v-icon left>mdi-account-plus</v-icon>
                    {{ $t('components.CustomerForm.SaveCustomerButtonLabel') }}
                </v-btn>
            </div>
        </div>
    </v-form>
</template>

<script>
import ReportControls from '@/components/customers/ReportControls';
import ABTestControls from '@/components/customers/ABTestControls';

import { appVersions } from '@/utils/CustomersAPI';

/**
 * CustomerForm abstracts a generic customer form with the required fields to 
 * perform any action over a customer between creation or edition. Its only a 
 * visual component.
 */
export default {
    name: 'CustomerForm',
    props: {
        customer: {
            type: Object
        },
        newCustomer: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        appVersions: appVersions,
        complete: true,
        form: {
            report: {},
            app_version: []
        },
        rules: {
            hidden: () => true,
            required: value => !!value || 'Required.',
            requiredList: value => (!!value && value.length > 0) || 'Required.',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
            }
        },
        reportFrecuencies: [
            'daily', 'weekly', 'monthly', false
        ],
    }),
    watch: {
        customer: {
            immediate: true,
            handler: function(value) {
                this.form = value? {...value} : { report: {} };
            }
        }
    },
    methods: {
        reportUpdated(customer) {
            this.form.report = customer.report;
        }
    },
    components: { ReportControls, ABTestControls }
}
</script>

<style scoped>
.col { padding: 6px !important; }
.v-input--selection-controls { margin-top: 0; }
</style>